/** Platform admin email; used for /admin access and UI (e.g. profile dropdown). */
export const ADMIN_EMAIL = "jw@justinwatsondesign.com"
